// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!./node_modules/css-loader/dist/cjs.js!./node_modules/@fontsource/roboto/400.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!./node_modules/css-loader/dist/cjs.js!./node_modules/@fontsource/roboto/500.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!./node_modules/css-loader/dist/cjs.js!./node_modules/@fontsource/roboto/700.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://js.arcgis.com/4.31/@arcgis/core/assets/esri/themes/light/main.css);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Load the ESRI javascript SDK css file. Custom! API Version */

/* Load google roboto font.*/
/*@import '@fontsource/roboto/300.css';*/ /* Regular */ /* Medium */ /* Bold */

body {
   overflow-y: hidden;
   /*background-color: LightSteelBlue ivory cornsilk ghostWhite, gainsboro */
}

/* Flex box rows. */
.app-flex-row-around {
   display: flex;
   justify-content: space-around;
   align-items: center;
}

.app-flex-row-between {
   display: flex;
   justify-content: space-between;
   align-items: center;
}

.app-flex-row-center {
   display: flex;
   justify-content: center;
   align-items: center;
}

.app-flex-row-evenly {
   display: flex;
   justify-content: space-evenly;
   align-items: center;
}

.app-flex-row-start {
   display: flex;
   justify-content: flex-start;
   align-items: center;
}

/* Flex box columns. */
.app-flex-column-around {
   display: flex;
   flex-direction: column;
   justify-content: space-around;
   align-items: center;
}

.app-flex-column-between {
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   align-items: center;
}

.app-flex-column-center {
   display: flex;
   flex-direction: column;
   justify-content: center;
   align-items: center;
}

.app-flex-column-start {
   display: flex;
   flex-direction: column;
   justify-content: flex-start;
   align-items: center;
}

/* CSS for printing a div. */
@media print {
   body * {
      visibility: hidden;
      /* transform: scale(1); */
      /* zoom: 100%; */
   }

   .hideForPrinting {
      width: 0;
      height: 0;
      overflow: hidden;
      display: none;
   }

   #print_div, #print_div * {
      visibility: visible;
   }

   #print_div {
      position: absolute;
      left: 0;
      top: 0;
      background-color: white;
      z-index: 999;
   }
}

/*==== Override ESRI popup. ====*/
.esri-popup__header-title {
   background-color: #CFD8DC;
}

/*=== Override ESRI navagation buttons. ===*/
.esri-widget--button {
   height: 36px;
   width: 36px;
}

.esri-widget--button, .esri-coordinate-conversion__heading .esri-coordinate-conversion__back-button {
/*   background-color: rgba(97, 125, 137, 0.95);
   color: white;
*/   
/*CUSTOM! Poway*/
   background-color: #1e3d5f;
   border-radius: 5px;
}

.esri-widget--button:hover, .esri-coordinate-conversion__heading .esri-coordinate-conversion__back-button:hover {
    background-color: rgb(87, 107, 117);
    color: white;
}

/* Custom CSS file */
calcite-icon:hover {
   --calcite-ui-icon-color: black;
}

/* For all other widgets icon color */
calcite-button.esri-widget--button {
   --calcite-color-text-3: white;
}

.esri-widget--button:focus {
   --calcite-color-text-3: black; /* For all other widgets icon color */
}

/*.esri-icon, .esri-icon-left-arrow, .esri-icon-right-arrow, .esri-icon-up, .esri-icon-down, .esri-icon-refresh,
.esri-icon-edit, .esri-icon-map-pin, .esri-icon-settings2, .esri-icon-duplicate, .esri-icon-search, .esri-icon-dial, .esri-icon-compass {
   color: white;
}*/

.esri-icon-close, .esri-icon-edit {
   color: silver; /* Restore icon colors. */
}

/*.esri-sketch__button.esri-icon-map-pin {
   color: grey;  Restore sketch icon color. 
}*/

/*.esri-component.esri-zoom {
   background-color: transparent;
   box-shadow: none;
}*/

/*=== Bookmarks. ===*/
.esri-bookmarks {
   --calcite-font-size--2: 0.90rem;
   --calcite-font-weight-normal: 500;
}

/*=== layerList.  0.875rem 0.9375 ===*/
.esri-layer-list {
   --calcite-font-size--1: 0.90rem;
   --calcite-font-weight-normal: 500;
}

/*=== Copyright attribution. ===*/
.esri-attribution {
   background-color: rgba(255,255,255, 0.50);
   color: black;
}

/*=== Geocoding search widget ===*/
.esri-search {
   width: 325px;
}

.esri-search__input {
   margin-left: 5px;
   margin-right: 3px;
   border: 1px solid silver;
   border-radius: 3px;
}

/*=== Override ESRI map bottom status bar tools. ===*/
.esri-basemap-toggle__image {
   border-radius: 5px;
   border: 2px solid rgb(120,144,156);
}

/*=======================================*/
.esri-coordinate-conversion.esri-widget {
   width: 370px;
   background-color: rgba(120,144,156, 0.50);
   border-radius: 5px;
}

.esri-coordinate-conversion__display {
   /*color: black;*/
   background-color: rgba(210,220,225, 0.90);
   font-weight: bold;
}

.esri-coordinate-conversion__input-group label {
   background-color: rgba(210,220,225, 0.70);
}

.esri-coordinate-conversion__heading {
   background-color: rgba(120,144,156, 0.70);
}

.esri-coordinate-conversion__display:hover {
   background-color: rgb(210,220,225);
}

.esri-coordinate-conversion__select-row {
   /*background-color: rgba(210,220,225, 0.50);*/
   /*CUSTOM! Poway*/
   background-color: rgba(210,220,225, 0.70);
}
/*=======================================*/
.esri-scale-bar__label-container--ruler .esri-scale-bar__label {
   padding: 0;
   padding-left: 2px;
   padding-right: 2px;
   color: black;
   background-color: rgba(255,255,255,0.70);
   margin-top: 3px;
   border-radius: 1px;
}

.esri-basemap-gallery__item-title {
   font-size: 0.90rem;
   color: black;
}

/*=== End override ESRI widgets. ===*/

/*=== CUSTOM! Poway Overrides  ===*/
div[title="Choose results to show"] > svg {
   color: white;
}
`, "",{"version":3,"sources":["webpack://./app.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAG/D,4BAA4B;AAC5B,wCAAwC,EACF,YAAY,EACZ,WAAW,EACX,SAAS;;AAE/C;GACG,kBAAkB;GAClB,yEAAyE;AAC5E;;AAEA,mBAAmB;AACnB;GACG,aAAa;GACb,6BAA6B;GAC7B,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,8BAA8B;GAC9B,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,uBAAuB;GACvB,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,6BAA6B;GAC7B,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,2BAA2B;GAC3B,mBAAmB;AACtB;;AAEA,sBAAsB;AACtB;GACG,aAAa;GACb,sBAAsB;GACtB,6BAA6B;GAC7B,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,8BAA8B;GAC9B,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,uBAAuB;GACvB,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,sBAAsB;GACtB,2BAA2B;GAC3B,mBAAmB;AACtB;;AAEA,4BAA4B;AAC5B;GACG;MACG,kBAAkB;MAClB,yBAAyB;MACzB,gBAAgB;GACnB;;GAEA;MACG,QAAQ;MACR,SAAS;MACT,gBAAgB;MAChB,aAAa;GAChB;;GAEA;MACG,mBAAmB;GACtB;;GAEA;MACG,kBAAkB;MAClB,OAAO;MACP,MAAM;MACN,uBAAuB;MACvB,YAAY;GACf;AACH;;AAEA,iCAAiC;AACjC;GACG,yBAAyB;AAC5B;;AAEA,4CAA4C;AAC5C;GACG,YAAY;GACZ,WAAW;AACd;;AAEA;AACA;;CAEC;AACD,gBAAgB;GACb,yBAAyB;GACzB,kBAAkB;AACrB;;AAEA;IACI,mCAAmC;IACnC,YAAY;AAChB;;AAEA,oBAAoB;AACpB;GACG,8BAA8B;AACjC;;AAEA,qCAAqC;AACrC;GACG,6BAA6B;AAChC;;AAEA;GACG,6BAA6B,EAAE,qCAAqC;AACvE;;AAEA;;;EAGE;;AAEF;GACG,aAAa,EAAE,yBAAyB;AAC3C;;AAEA;;EAEE;;AAEF;;;EAGE;;AAEF,qBAAqB;AACrB;GACG,+BAA+B;GAC/B,iCAAiC;AACpC;;AAEA,sCAAsC;AACtC;GACG,+BAA+B;GAC/B,iCAAiC;AACpC;;AAEA,iCAAiC;AACjC;GACG,yCAAyC;GACzC,YAAY;AACf;;AAEA,kCAAkC;AAClC;GACG,YAAY;AACf;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,wBAAwB;GACxB,kBAAkB;AACrB;;AAEA,qDAAqD;AACrD;GACG,kBAAkB;GAClB,kCAAkC;AACrC;;AAEA,0CAA0C;AAC1C;GACG,YAAY;GACZ,yCAAyC;GACzC,kBAAkB;AACrB;;AAEA;GACG,gBAAgB;GAChB,yCAAyC;GACzC,iBAAiB;AACpB;;AAEA;GACG,yCAAyC;AAC5C;;AAEA;GACG,yCAAyC;AAC5C;;AAEA;GACG,kCAAkC;AACrC;;AAEA;GACG,6CAA6C;GAC7C,gBAAgB;GAChB,yCAAyC;AAC5C;AACA,0CAA0C;AAC1C;GACG,UAAU;GACV,iBAAiB;GACjB,kBAAkB;GAClB,YAAY;GACZ,wCAAwC;GACxC,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,kBAAkB;GAClB,YAAY;AACf;;AAEA,qCAAqC;;AAErC,mCAAmC;AACnC;GACG,YAAY;AACf","sourcesContent":["/* Load the ESRI javascript SDK css file. Custom! API Version */\r\n@import \"https://js.arcgis.com/4.31/@arcgis/core/assets/esri/themes/light/main.css\";\r\n\r\n/* Load google roboto font.*/\r\n/*@import '@fontsource/roboto/300.css';*/\r\n@import '@fontsource/roboto/400.css'; /* Regular */\r\n@import '@fontsource/roboto/500.css'; /* Medium */\r\n@import '@fontsource/roboto/700.css'; /* Bold */\r\n\r\nbody {\r\n   overflow-y: hidden;\r\n   /*background-color: LightSteelBlue ivory cornsilk ghostWhite, gainsboro */\r\n}\r\n\r\n/* Flex box rows. */\r\n.app-flex-row-around {\r\n   display: flex;\r\n   justify-content: space-around;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-row-between {\r\n   display: flex;\r\n   justify-content: space-between;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-row-center {\r\n   display: flex;\r\n   justify-content: center;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-row-evenly {\r\n   display: flex;\r\n   justify-content: space-evenly;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-row-start {\r\n   display: flex;\r\n   justify-content: flex-start;\r\n   align-items: center;\r\n}\r\n\r\n/* Flex box columns. */\r\n.app-flex-column-around {\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: space-around;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-column-between {\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: space-between;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-column-center {\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: center;\r\n   align-items: center;\r\n}\r\n\r\n.app-flex-column-start {\r\n   display: flex;\r\n   flex-direction: column;\r\n   justify-content: flex-start;\r\n   align-items: center;\r\n}\r\n\r\n/* CSS for printing a div. */\r\n@media print {\r\n   body * {\r\n      visibility: hidden;\r\n      /* transform: scale(1); */\r\n      /* zoom: 100%; */\r\n   }\r\n\r\n   .hideForPrinting {\r\n      width: 0;\r\n      height: 0;\r\n      overflow: hidden;\r\n      display: none;\r\n   }\r\n\r\n   #print_div, #print_div * {\r\n      visibility: visible;\r\n   }\r\n\r\n   #print_div {\r\n      position: absolute;\r\n      left: 0;\r\n      top: 0;\r\n      background-color: white;\r\n      z-index: 999;\r\n   }\r\n}\r\n\r\n/*==== Override ESRI popup. ====*/\r\n.esri-popup__header-title {\r\n   background-color: #CFD8DC;\r\n}\r\n\r\n/*=== Override ESRI navagation buttons. ===*/\r\n.esri-widget--button {\r\n   height: 36px;\r\n   width: 36px;\r\n}\r\n\r\n.esri-widget--button, .esri-coordinate-conversion__heading .esri-coordinate-conversion__back-button {\r\n/*   background-color: rgba(97, 125, 137, 0.95);\r\n   color: white;\r\n*/   \r\n/*CUSTOM! Poway*/\r\n   background-color: #1e3d5f;\r\n   border-radius: 5px;\r\n}\r\n\r\n.esri-widget--button:hover, .esri-coordinate-conversion__heading .esri-coordinate-conversion__back-button:hover {\r\n    background-color: rgb(87, 107, 117);\r\n    color: white;\r\n}\r\n\r\n/* Custom CSS file */\r\ncalcite-icon:hover {\r\n   --calcite-ui-icon-color: black;\r\n}\r\n\r\n/* For all other widgets icon color */\r\ncalcite-button.esri-widget--button {\r\n   --calcite-color-text-3: white;\r\n}\r\n\r\n.esri-widget--button:focus {\r\n   --calcite-color-text-3: black; /* For all other widgets icon color */\r\n}\r\n\r\n/*.esri-icon, .esri-icon-left-arrow, .esri-icon-right-arrow, .esri-icon-up, .esri-icon-down, .esri-icon-refresh,\r\n.esri-icon-edit, .esri-icon-map-pin, .esri-icon-settings2, .esri-icon-duplicate, .esri-icon-search, .esri-icon-dial, .esri-icon-compass {\r\n   color: white;\r\n}*/\r\n\r\n.esri-icon-close, .esri-icon-edit {\r\n   color: silver; /* Restore icon colors. */\r\n}\r\n\r\n/*.esri-sketch__button.esri-icon-map-pin {\r\n   color: grey;  Restore sketch icon color. \r\n}*/\r\n\r\n/*.esri-component.esri-zoom {\r\n   background-color: transparent;\r\n   box-shadow: none;\r\n}*/\r\n\r\n/*=== Bookmarks. ===*/\r\n.esri-bookmarks {\r\n   --calcite-font-size--2: 0.90rem;\r\n   --calcite-font-weight-normal: 500;\r\n}\r\n\r\n/*=== layerList.  0.875rem 0.9375 ===*/\r\n.esri-layer-list {\r\n   --calcite-font-size--1: 0.90rem;\r\n   --calcite-font-weight-normal: 500;\r\n}\r\n\r\n/*=== Copyright attribution. ===*/\r\n.esri-attribution {\r\n   background-color: rgba(255,255,255, 0.50);\r\n   color: black;\r\n}\r\n\r\n/*=== Geocoding search widget ===*/\r\n.esri-search {\r\n   width: 325px;\r\n}\r\n\r\n.esri-search__input {\r\n   margin-left: 5px;\r\n   margin-right: 3px;\r\n   border: 1px solid silver;\r\n   border-radius: 3px;\r\n}\r\n\r\n/*=== Override ESRI map bottom status bar tools. ===*/\r\n.esri-basemap-toggle__image {\r\n   border-radius: 5px;\r\n   border: 2px solid rgb(120,144,156);\r\n}\r\n\r\n/*=======================================*/\r\n.esri-coordinate-conversion.esri-widget {\r\n   width: 370px;\r\n   background-color: rgba(120,144,156, 0.50);\r\n   border-radius: 5px;\r\n}\r\n\r\n.esri-coordinate-conversion__display {\r\n   /*color: black;*/\r\n   background-color: rgba(210,220,225, 0.90);\r\n   font-weight: bold;\r\n}\r\n\r\n.esri-coordinate-conversion__input-group label {\r\n   background-color: rgba(210,220,225, 0.70);\r\n}\r\n\r\n.esri-coordinate-conversion__heading {\r\n   background-color: rgba(120,144,156, 0.70);\r\n}\r\n\r\n.esri-coordinate-conversion__display:hover {\r\n   background-color: rgb(210,220,225);\r\n}\r\n\r\n.esri-coordinate-conversion__select-row {\r\n   /*background-color: rgba(210,220,225, 0.50);*/\r\n   /*CUSTOM! Poway*/\r\n   background-color: rgba(210,220,225, 0.70);\r\n}\r\n/*=======================================*/\r\n.esri-scale-bar__label-container--ruler .esri-scale-bar__label {\r\n   padding: 0;\r\n   padding-left: 2px;\r\n   padding-right: 2px;\r\n   color: black;\r\n   background-color: rgba(255,255,255,0.70);\r\n   margin-top: 3px;\r\n   border-radius: 1px;\r\n}\r\n\r\n.esri-basemap-gallery__item-title {\r\n   font-size: 0.90rem;\r\n   color: black;\r\n}\r\n\r\n/*=== End override ESRI widgets. ===*/\r\n\r\n/*=== CUSTOM! Poway Overrides  ===*/\r\ndiv[title=\"Choose results to show\"] > svg {\r\n   color: white;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
